<ng-container *vnDynamicComponent="component" />
